module.exports = __webpack_public_path__ + "img/icon-twitter.72c6891c.svg";